export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.userId = payload.userId;
    state.email = payload.email;
  },
  setEmailVerified(state, payload) {
    state.emailVerified = payload
  }
}